import React from 'react';

export default function ContactUs() {
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Contact Us</h1>
      <p>📞 Phone: 7299624746</p>
      <p>📧 Email: vanigamm360@gmail.com</p>
      <p>📍 Address: 11/27, Tholkappian Street, Anna Nagar, Chitlapakkam, Chennai 600064</p>
    </div>
  );
}
